import React, {Component, MutableRefObject, useEffect, useRef, useState} from "react";
import {SelectOutlined} from "@ant-design/icons";
import {Button} from "antd";
import {EventService, IEvent} from "../services/eventService";

type Props = {
    onCursorChange: (cursor: string) => void
    setRef: MutableRefObject<null>
    userId: string,
    taskId: string
};

export default function SelectInspector(props: Props) {
    useOutsideAlerter(props.setRef);

    const [inspecting, setInspecting] = useState(false);
    const eventService = new EventService();

    function updateInspector() {
        if (inspecting) {
            props.onCursorChange('default');
            setInspecting(false);
            sendEvent("SELECT_INSPECTOR_OFF", {});
        } else {
            setInspecting(true);
            props.onCursorChange('crosshair');
            sendEvent("SELECT_INSPECTOR_ON", {});
        }
    }

    function sendEvent(type: "SELECT_INSPECTOR_ON" | "SELECT_INSPECTOR_OFF", value: any) {
        const date = new Date();
        eventService.saveEvent(props.userId, props.taskId, {
            id: date.getTime(),
            time: date.toString(),
            type,
            value
        });
    }

    function useOutsideAlerter(ref: any) {
        useEffect(() => {
            /**
             * Alert if clicked on outside of element
             */
            function handleClickOutside(event: any) {
                if (ref.current && !ref.current.contains(event.target)) {
                    props.onCursorChange('default');
                    setInspecting(false);
                    sendEvent("SELECT_INSPECTOR_OFF", {});
                }
            }

            // Bind the event listener
            document.addEventListener("mousedown", handleClickOutside);
            return () => {
                // Unbind the event listener on clean up
                document.removeEventListener("mousedown", handleClickOutside);
            };
        }, [ref]);
    }

    return (
        <Button
            ref={props.setRef}
            type="primary"
            icon={<SelectOutlined />}
            onClick={() => updateInspector()}
            size="large">Row Inspector
        </Button>);
}